// 判定一个 hash 是否为锚点
// 锚点的两大特征
// 1. 必然有一个 id 为 hash 的元素
// 2. 页面内容必然不发生变化，体现在页面文本长度上
function isAnchor(hash) {
  if (!hash || hash === '#') return false;
  var newHash = hash.substr(1); // eslint-disable-line no-param-reassign
  if (newHash[0] === '/') return false;

  // 去除 hash 中的 query
  var idx = newHash.indexOf('?');
  if (idx !== -1) newHash = newHash.substr(0, idx); // eslint-disable-line no-param-reassign

  var queryDom = document.getElementById(decodeURI(newHash));
  return queryDom !== null && queryDom !== undefined;
}
export function parse(url) {
  var arr = url.split('//');
  var protocol = arr[0];
  var temp1 = arr[1] || '';
  var arr1 = temp1.split('/');
  var host = arr1[0];
  var arr2 = host.split(':');
  var hostname = arr2[0];
  var port = arr2[1] || '';
  var temp2 = temp1.replace(host, '');
  var arr3 = temp2.split('#');
  var path = arr3[0];
  var hashAfter = arr3[1] || '';
  var hash = hashAfter ? "#".concat(hashAfter) : null;
  var arr4 = path.split('?');
  var pathname = arr4[0];
  var query = arr4[1] || '';
  var search = query ? "?".concat(query) : null;
  var obj = {
    protocol: protocol,
    slashes: true,
    auth: null,
    host: host,
    port: port || null,
    hostname: hostname,
    hash: hash,
    search: search,
    query: query || null,
    pathname: pathname,
    path: path,
    href: url,
    hashIsAnchor: isAnchor(hash),
    // true or false
    format: function format() {
      return "".concat(obj.protocol, "//").concat(obj.host).concat(obj.path).concat(obj.hash || '');
    }
  };
  return obj;
}
export default {
  parse: parse,
  isAnchor: isAnchor
};